import React, {Component} from 'react';
import {connect} from 'react-redux';
import {buildFuneralHomeFlowersUrl} from '../../../../../shared/utilities/urlHelpers';
import {gaClickHandler} from '../../../../../shared/utilities/GAHelpers';
import Header from '../../../../../shared/library/Header/Header';
import CalendarEvent from './CalendarEvent';
import FlowersAd from '../../Shared/FlowersAd';
import SearchObituaries from '../../Shared/SearchObituaries/SearchObituaries';
import imageFlower1 from '../../Shared/FlowersAd/assets/flower1.jpg';
import imageFlower2 from '../../Shared/FlowersAd/assets/flower2.jpg';
import imageFlower3 from '../../Shared/FlowersAd/assets/flower3.jpg';
import './css/UpcomingServices.styl';

export class UpcomingServices extends Component {
  static propTypes = {
    upcomingServices: React.PropTypes.object,
    funeralHome: React.PropTypes.object,
    planning: React.PropTypes.bool.isRequired,
    isMobile: React.PropTypes.bool,
  };

  hasUpcomingServices(upcomingServices) {
    return (
      upcomingServices &&
      upcomingServices.people &&
      upcomingServices.people.length > 0
    );
  }

  renderUpcomingServices(upcomingServices) {
    if (this.hasUpcomingServices(upcomingServices)) {
      return (
        <div className="upcoming-services-tab__events-container">
          <Header type={'no-border'} title="Upcoming Services" />
          {upcomingServices.people.map((value, index) => (
            <CalendarEvent key={index} data={value} />
          ))}
        </div>
      );
    }
    return null;
  }

  render() {
    const {
      affiliateId,
      funeralHome,
      upcomingServices = {people: []},
      planning,
      isMobile,
    } = this.props;
    const {funeralHomeId, name, location, flowerSettings} = funeralHome;
    const flowersUrlOptions = {
      funeralHomeId,
      funeralHomeName: name,
      affiliateId,
      cultureCode: location.country.cultureCode,
      flowerSettings,
      isMobile,
    };
    const flowersAdsItems = [
      {
        image: imageFlower1,
        text: 'The FTD® Comfort™ Planter',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
      {
        image: imageFlower2,
        text: 'The FTD® Faithful Blessings™ Bouquet - VASE INCLUDED',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
      {
        image: imageFlower3,
        text: 'The FTD® Eternal Affection™ Arrangement',
        link: buildFuneralHomeFlowersUrl(flowersUrlOptions),
      },
    ];

    return (
      <div className="upcoming-services-tab">
        <Header title="Attending The Funeral" />
        <div className="tab-overview">
          {!this.hasUpcomingServices(upcomingServices) && (
            <p>
              No upcoming services are currently listed. Updates will appear on
              this page as obituaries are published.
            </p>
          )}
          <p>
            We encourage you to contact the funeral home to verify time and
            location before attending services or visitation.
          </p>
          <p>
            To send flowers to {this.props.funeralHome.name} please visit our{' '}
            <a
              href={buildFuneralHomeFlowersUrl(flowersUrlOptions)}
              className="link-flowers-store"
              data-ga-no-auto-tag
              onClick={gaClickHandler(
                'fhd_flowers',
                'fhd_flowers_click',
                'fhd_flowers_store'
              )}
            >
              sympathy store
            </a>
            .
          </p>
        </div>
        {this.renderUpcomingServices(upcomingServices)}
        {!planning && (
          <FlowersAd
            flowersAdItems={flowersAdsItems}
            flowersUrlOptions={flowersUrlOptions}
          />
        )}
        <div className="upcoming-services-tab__search-obituaries">
          <Header type={'no-border'} title="Search Obituaries" />
          <SearchObituaries />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    upcomingServices: state.upcomingServicesStore,
    funeralHome: state.funeralHomeStore,
    planning: state.planningStore.isPlanning,
    affiliateId: state.affiliateStore.sourceId,
    isMobile: state.mobileDetailsStore.any,
  };
};

export default connect(mapStateToProps)(UpcomingServices);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/UpcomingServices/index.js